import { LozengeSize, LozengeVariant } from '@/atoms/Lozenge/Lozenge'

const getSizeClassNames = (size: LozengeSize) => {
  switch (size) {
    case 'sm':
      return 'lozenge-sm'
    case 'md':
      return 'lozenge-md'
    case 'lg':
      return 'lozenge-lg'
  }
}

const getVariantClassNames = (variant: LozengeVariant, isDarkMode: boolean) => {
  switch (variant) {
    case 'neutral':
      return isDarkMode ? 'bg-core-gray-900 text-core-gray-400' : 'bg-core-gray-200 text-core-gray-800'
    case 'outlined':
      return isDarkMode
        ? 'bg-transparent border border-core-gray-800 text-core-gray-400'
        : 'bg-transparent border border-core-gray-300 text-core-gray-800'
    case 'transparent':
      return isDarkMode ? 'bg-black/30 backdrop-blur-[48px] text-white' : 'bg-white/30 backdrop-blur-[48px] text-black'
    case 'brand':
      return 'bg-copper text-white'
  }
}

export const getLozengeClassNames = (variant: LozengeVariant, size: LozengeSize, isDarkMode: boolean) => {
  return `${getSizeClassNames(size)} ${getVariantClassNames(variant, isDarkMode)}`
}
